import { SegmentedButton } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

import { constants } from '@hero/configs';

const Description = styled.p`
  color: var(--color-neutral-800);
  font-size: 14px;
  margin-bottom: 16px;
`;

const DigitalWrapperFirstContent = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 12px 0 8px;
`;

const DigitalWrapperFirstContentSelect = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  width: 350px;
`;

const DigitalWrapper = styled.div`
  position: relative;

  .tab-button {
    font-size: 14px;
    min-width: 200px;
  }

  ${constants?.products?.card?.width &&
  css`
    img {
      object-position: top left;
      transform: scale(2.5);
      transform-origin: top left;
    }
  `}

  ${SegmentedButton.S.SegmentedButtonContent} {
    margin-top: 0;
    padding-top: 0;
  }
`;

const ImagePreviewWrapper = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(7, 1fr);
  margin-bottom: 16px;
`;

const TitleWrapper = styled.div`
  margin-bottom: 16px;
`;

export {
  Description,
  DigitalWrapper,
  DigitalWrapperFirstContent,
  DigitalWrapperFirstContentSelect,
  ImagePreviewWrapper,
  TitleWrapper
};
